import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import * as React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

const appElement = React.createElement(App);
ReactDOM.render(appElement, document.getElementById("root"));
